import { render, staticRenderFns } from "./BosHeader.vue?vue&type=template&id=a4ed279a&scoped=true"
import script from "./BosHeader.vue?vue&type=script&lang=js"
export * from "./BosHeader.vue?vue&type=script&lang=js"
import style0 from "./BosHeader.vue?vue&type=style&index=0&id=a4ed279a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ed279a",
  null
  
)

export default component.exports